import { FC } from 'react';

import { useSelectorNonNullable } from 'src/hooks/useSelector';
import { Tariff, ZpTabName } from 'src/models/price/priceZp';
import { ZpTariff } from 'src/models/price/zpTariff';
import { isZpEventProduct } from 'src/utils/price/products';

import BrandingFeatures from 'src/pages/PriceZp/components/BrandingFeatures';
import BundlesFeatures from 'src/pages/PriceZp/components/BundlesFeatures';
import PromotionFeatures from 'src/pages/PriceZp/components/PromotionFeatures';
import PublicationsFeatures from 'src/pages/PriceZp/components/PublicationsFeatures';
import ResumeAccessFeatures from 'src/pages/PriceZp/components/ResumeAccessFeatures';

const TariffFeatures: FC<{ tariff: Tariff }> = ({ tariff }) => {
    const tabName = useSelectorNonNullable(({ priceZp }) => priceZp.tabName);

    if (tariff.product && isZpEventProduct(tariff.product)) {
        return null;
    }
    if (tariff.tariffName === ZpTariff.Branding) {
        return <BrandingFeatures />;
    }
    if (tabName === ZpTabName.ZpResumeAccess) {
        return <ResumeAccessFeatures tariff={tariff} />;
    }
    if (tabName === ZpTabName.ZpPublications) {
        return <PublicationsFeatures tariff={tariff} />;
    }
    if (tabName === ZpTabName.ZpBundles) {
        return <BundlesFeatures tariff={tariff} />;
    }
    if (tabName === ZpTabName.ZpPromotion) {
        return <PromotionFeatures tariff={tariff} />;
    }
    return null;
};

export default TariffFeatures;
